/* global adobe */

import RiotControl from 'riotcontrol'
import cookie from 'cookie-cutter'
import logger from '../logger'
import extendedObservable from './base'
import appProps from '#util/app-props'
import {
  isEmpty,
  isPlainObject,
  isArray,
} from 'lodash-es'

const getters = {}

class TestsObservable {
  constructor() {
    extendedObservable(this, 'testsModel', { activeTests: {} }, getters)

    // register and unregister event listeners
    this.on('registerTestsObserver', (observer) => {
      this.registerObserver(observer)
      if (observer.name === 'applicationObservable') {
        RiotControl.trigger('updateAppModelManually', 'activeTests', this.model.activeTests)
      }
    })
    this.on('unregisterTestsObserver', observer => this.unregisterObserver(observer))

    Object.defineProperty(this.model, 'getTestVariant', {
      value: (id) => {
        if (this.isTestEnabled(id)) {
          return this.model.activeTests[id]
        }
        // no test active
        return null
      },
      enumerable: true,
      configurable: false,
    })

    this.on('reiTEST', (data) => {
      parseTestData(data)
        .then(parsedData => negotiateAndUpdateTestOverrides(this.model, parsedData))
        .then(this.notifyObservers)
    })

    this.checkToInitAdobe = orderModel => new Promise((resolve, reject) => {
      if (typeof adobe !== 'undefined' && adobe.target) {
        // Initializes the document listener for Adobe Tests.
        // Listens for a custom event `reiTEST` (case sensitive)
        // on the document with a specific payload schema.
        initializeTestHookListener()

        // Initializes Adobe
        initAdobe(orderModel, resolve, reject)
      } else {
        // else, do nothing, already initialized
        initializeTestHookListener()
        resolve()
      }
    })

    this.isTestEnabled = id => !isEmpty(this.model.activeTests) && !isEmpty(this.model.activeTests[id])

    this.getTestVariant = (id) => {
      if (this.isTestEnabled(id)) {
        return this.model.activeTests[id]
      }
      // no test active
      return null
    }

    const initializeTestHookListener = () => {
      // add an appropriate event listener
      document.addEventListener('reiTEST', (e) => {
        logger('REI Test detected. Dispatching event', 'info')()
        RiotControl.trigger('reiTEST', e.detail)
      })

      negotiateAndUpdateTestOverrides(this.model, {})
    }

    /**
     * Initializes Adobe
     * @return {none} no return
     *
     * If Adobe fails to apply correctly, swallow the error(s) so
     * that the application can continue to work.
     */
    const initAdobe = (orderModel, resolve) => {
      document.addEventListener(adobe.target.event.CONTENT_RENDERING_SUCCEEDED, resolve)
      document.addEventListener(adobe.target.event.CONTENT_RENDERING_FAILED, resolve)

      // Check to see if this user has a rSegment already
      let rSegment = cookie.get('rSegment')

      // If no segment, assign one
      if (!rSegment) {
        rSegment = Math.floor(Math.random() * 99)
        cookie.set('rSegment', rSegment, { expires: new Date(2147483647 * 1000).toUTCString() })
      }

      adobe.target.getOffer({
        mbox: appProps.get('adobe.testtarget.mbox', 'target-global-mbox-2'),
        params: {
          isGuest: orderModel.safeGet('user.isGuest'),
          memberType: orderModel.safeGet('customerInfo.memberType'),
          employeeType: orderModel.safeGet('customerInfo.employeeType'),
          rSegment,
        },
        success(offers) {
          if (offers.length) {
            try {
              adobe.target.applyOffer({
                mbox: appProps.get('adobe.testtarget.mbox', 'target-global-mbox-2'),
                offer: offers,
              })
              logger('A/B testing: offer applied!', 'debug')()
              // Resolve is called via the CONTENT_RENDERING_SUCCEEDED defined above
            } catch (e) {
              logger(`A/B testing: applyOffer error: ${e}`, 'warning')()
              resolve(e)
            }
          } else {
            resolve()
          }
        },
        error(e) {
          logger(`A/B testing: getOffer error: ${e}`, 'warning')()
          resolve(e)
        },
        timeout: 1000,
      })
    }

    const parseTestData = data => new Promise((resolve, reject) => {
      if (isPlainObject(data)) {
        resolve(data)
      } else if (isArray(data)) {
        const dataObj = {}
        data.forEach((value) => {
          Object.assign(dataObj, value)
        })

        resolve(dataObj)
      } else {
        // reject the event payload
        reject()
      }
    })

    const negotiateAndUpdateTestOverrides = (model, data) => {
      const testOverrides = appProps.get('test.overrides', {})
      // { 'id', 'variant' }
      // Apply test overrides last so they override the adobe settings
      if (!isEmpty(testOverrides)) {
        logger('Note: App Prop Test Overrides are in effect!', 'warning')()
        logger(testOverrides, 'warning')()
      }
      const negotiated = Object.assign(model.activeTests || {}, data, testOverrides)
      logger('testsModel updated:', 'info')()
      logger(this.model, 'info')()
      return negotiated
    }
  }
}

export const TestsObservableInstance = new TestsObservable();
